import { render, staticRenderFns } from "./AccountsTree.vue?vue&type=template&id=1d97ab7b&scoped=true"
import script from "./AccountsTree.vue?vue&type=script&lang=js"
export * from "./AccountsTree.vue?vue&type=script&lang=js"
import style0 from "./AccountsTree.vue?vue&type=style&index=0&id=1d97ab7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d97ab7b",
  null
  
)

export default component.exports